/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — this models a single lump-sum deposit. For recurring monthly contributions, use the SIP calculator; for paying down a loan, see the loan calculator.`)
};

const es_cp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — esto modela un depósito único de una sola vez. Para contribuciones mensuales recurrentes, usa la calculadora SIP; para pagar un préstamo, ver la calculadora de préstamos.`)
};

const de_cp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein — dies bildet eine einzelne Einmaleinzahlung ab. Für wiederkehrende monatliche Einzahlungen verwenden Sie den SIP-Rechner; für die Rückzahlung eines Kredits siehe den Kreditrechner.`)
};

const nl_cp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee — dit modelleert een enkele eenmalige inleg. Voor terugkerende maandelijkse inbrengsten gebruikt u de SIP-calculator; voor het aflossen van een lening raadpleegt u de leningcalculator.`)
};

const fr_cp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non — ceci modélise un dépôt forfaitaire unique. Pour les contributions mensuelles récurrentes, utilisez la calculatrice SIP ; pour rembourser un prêt, consultez la calculatrice de prêt.`)
};

const it_cp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — questo modella un singolo deposito in un'unica soluzione. Per i contributi mensili ricorrenti, usa il calcolatore SIP; per pagare un prestito, consulta il calcolatore del prestito.`)
};

const pt_br2_cp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — isto modela um depósito único. Para contribuições mensais recorrentes, use a calculadora SIP; para amortizar um empréstimo, veja a calculadora de empréstimos.`)
};

const pt_cp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — isto modela um depósito único em montante fixo. Para contribuições mensais recorrentes, utilize a calculadora SIP; para amortizar um empréstimo, consulte a calculadora de empréstimos.`)
};

const ja_cp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。これは一度の預金をモデル化しています。定期的な毎月貢献の場合は、SIP計算ツールを使用してください。ローンを返済する場合は、ローン計算ツールを参照してください。`)
};

const zh_cp_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不包含——此工具模拟的是一次性整存款项。如需定期每月投入，请使用SIP计算器；如需偿还贷款，请参阅贷款计算器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq2_a", locale)
	if (locale === "en") return en_cp_faq2_a(inputs)
	if (locale === "es") return es_cp_faq2_a(inputs)
	if (locale === "de") return de_cp_faq2_a(inputs)
	if (locale === "nl") return nl_cp_faq2_a(inputs)
	if (locale === "fr") return fr_cp_faq2_a(inputs)
	if (locale === "it") return it_cp_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq2_a(inputs)
	if (locale === "pt") return pt_cp_faq2_a(inputs)
	if (locale === "ja") return ja_cp_faq2_a(inputs)
	return zh_cp_faq2_a(inputs)
};